<template>
    <div class="container-fluid" v-if="tracker && posicao">

        <header-admin :rastreador="tracker" :posicao="posicao" :veiculo="veiculo"></header-admin>

        <vk-tabs :keep-alive="true">

            <vk-tabs-item title="INICIAL">
                <positions-maps :posicao="posicao"/>
            </vk-tabs-item>

            <vk-tabs-item title="COMANDOS" v-if="rastreador">

                <br/>

                <div class="col-sm-3">
                    <enviar-saidas :enable_output2="true" :id_rastreador="rastreador.id_rastreador"/><br/>
                    <reset :id_rastreador="rastreador.id_rastreador"/><br/>
                    <solicitar-configuracao :id_rastreador="rastreador.id_rastreador"/>
                    <solicitar-posicao :id_rastreador="rastreador.id_rastreador"/>
                </div>

                <div class="col-sm-9">
                    <table-comandos :id_rastreador="rastreador.id_rastreador"/>
                </div>

            </vk-tabs-item>

            <vk-tabs-item title="PROBLEMAS" v-if="veiculo">
                <problemas  @reload="loadVeiculo($event)" :veiculo="veiculo"></problemas>
            </vk-tabs-item>

            <vk-tabs-item title="VEÍCULO" v-if="veiculo">
                <dados-do-veiculo-admin :veiculo="veiculo"/>
            </vk-tabs-item>

            <vk-tabs-item title="CLIENTE" v-if="cliente">
                <dados-do-cliente-admin :cliente="cliente"/>
            </vk-tabs-item>

            <vk-tabs-item title="RELATÓRIOS" v-if="veiculo">
               <dados-relatorios-admin :veiculo="veiculo"/>
            </vk-tabs-item>

            <vk-tabs-item title="CONFIGURAÇÃO" v-if="config">
                <vk-tabs-vertical keep-alive>

                    <vk-tabs-item title="COMANDO LIVRE" >
                        <comando-livre :id_rastreador="rastreador.id_rastreador"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="TEMPOS" >
                        <tempos-vitana :config="config"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="APN">
                        <apn-vitana :config="config"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="IP">
                        <ip-vitana :config="config"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="ANGULO">
                        <angle :id_rastreador="rastreador.id_rastreador"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="RFID">
                        <rfid-vitana :id_rastreador="rastreador.id_rastreador"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="HODOMETRO" v-if="rastreador">
                        <br/>
                        <ajustar-hodometro :id_rastreador="rastreador.id_rastreador"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="BLOQUEIO">
                        <bloqueio-vitana :config="config"/>
                    </vk-tabs-item>

                </vk-tabs-vertical>
            </vk-tabs-item>

        </vk-tabs>

    </div>
    <div class="container-fluid" v-else>
        <center>
            <h1>Aguardando dados e primeira transmissão</h1>
        </center>
        <vk-tabs :keep-alive="true">

            <vk-tabs-item title="COMANDOS" v-if="rastreador">

                <br/>

                <div class="col-sm-3">
                    <enviar-saidas :enable_output2="true" :id_rastreador="rastreador.id_rastreador"/><br/>
                    <reset :id_rastreador="rastreador.id_rastreador"/><br/>
                    <solicitar-configuracao :id_rastreador="rastreador.id_rastreador"/>
                    <solicitar-posicao :id_rastreador="rastreador.id_rastreador"/>
                </div>

                <div class="col-sm-9">
                    <table-comandos :id_rastreador="rastreador.id_rastreador"/>
                </div>

            </vk-tabs-item>

            <vk-tabs-item title="CONFIGURAÇÃO" v-if="config">
                <vk-tabs-vertical keep-alive>

                    <vk-tabs-item title="COMANDO LIVRE" >
                        <comando-livre :id_rastreador="rastreador.id_rastreador"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="TEMPOS" >
                        <tempos-vitana :config="config"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="APN">
                        <apn-vitana :config="config"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="IP">
                        <ip-vitana :config="config"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="HODOMETRO" v-if="rastreador">
                        <br/>
                        <ajustar-hodometro :id_rastreador="rastreador.id_rastreador"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="ANGULO">
                        <angle :config="config"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="BLOQUEIO">
                        <bloqueio-vitana :config="config"/>
                    </vk-tabs-item>

                </vk-tabs-vertical>
            </vk-tabs-item>

        </vk-tabs>
    </div>
</template>
<script>
    import SolicitarConfiguracao from '../../components/buttons/SolicitarConfiguracao.vue';
    import HeaderAdmin from './HeaderAdmin';
    import EnviarSaidas from '../../components/buttons/EnviarSaidas';
    import HabilitarAlertaTransmissao from "../buttons/HabilitarAlertaTransmissao";
    import MapPosicao from "./partials/MapPosicao.vue";
    import PosicaoAtual from "./partials/PosicaoAtual.vue";
    import TableComandos from "../tables/TableComandos";
    import Reset from "../buttons/Reset";
    import GoogleMapsButton from "../buttons/GoogleMapsButton.vue";
    import GoogleEarthButton from "../buttons/GoogleEarthButton.vue";
    import PositionsMaps from './partials/PositionsMaps.vue';
    import Problemas from '../veiculo/Problemas.vue';
    import SolicitarPosicao from '../buttons/SolicitarPosicao.vue';
    import DadosDoVeiculoAdmin from './partials/DadosDoVeiculoAdmin.vue';
    import DadosDoClienteAdmin from './partials/DadosDoClienteAdmin.vue';
    import DadosRelatoriosAdmin from './partials/DadosRelatoriosAdmin.vue';
    import {veiculosAdminMixins} from './partials/veiculo-admin-mixins';
    import TemposVitana from './partials/vitana/TemposVitana.vue';
    import ApnVitana from './partials/vitana/ApnVitana.vue';
    import IpVitana from './partials/vitana/IpVitana.vue';
    import ComandoLivre from './partials/generico/ComandoLivre.vue';
    import {Vitana} from '../../class/vitana';
    import BloqueioVitana from './partials/vitana/BloqueioVitana.vue';
    import AjustarHodometro from './partials/AjustarHodometro.vue';
    import Angle from './partials/Angle.vue';
    import RfidVitana from './partials/vitana/RfidVitana.vue';

    export default {
        name: 'Vitana',

        components: {
            RfidVitana,
            ComandoLivre,
            Angle,
            AjustarHodometro,
            BloqueioVitana,
            IpVitana,
            ApnVitana,
            TemposVitana,
            DadosRelatoriosAdmin,
            DadosDoClienteAdmin, DadosDoVeiculoAdmin,
            SolicitarPosicao,
            Problemas,
            PositionsMaps,
            GoogleEarthButton,
            GoogleMapsButton,
            HabilitarAlertaTransmissao,
            EnviarSaidas,
            HeaderAdmin,
            PosicaoAtual, MapPosicao, TableComandos, Reset,
            SolicitarConfiguracao,
        },

        data(){
            return {
                config: null,
            };
        },

        mixins: [
            veiculosAdminMixins
        ],

        async beforeMount(){
            this.config = await Vitana.byPK(this.rastreador.id_rastreador);
        },
    };
</script>
